import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { customApp } from '../../_configuration/configuration';
import { v5 as uuidv5 } from 'uuid';
import { v4 as uuidv4 } from 'uuid';
import { TicketcodeAuthService } from '../_auth/ticketcode-auth.service';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class BoothAnalyticsService {
  constructor(private http: HttpClient, private ticketcodeAuthService: TicketcodeAuthService) {}
  viewObject = {
    timeStamp: 0,
    boothId: ''
  };

  startDuration(boothId: string) {
    this.viewObject = {
      timeStamp: new Date().getTime(),
      boothId
    };
  }

  newBoothView(attendeeId?: string) {
    let duration = 0;
    if (this.viewObject.timeStamp !== 0) {
      duration = new Date().getTime() - this.viewObject.timeStamp;
    } else {
      this.viewObject.timeStamp = new Date().getTime();
    }
    this.http
      .post(customApp.url + '/app/event/tradeFair/booth/analytics/newView', {
        timeStamp: this.viewObject.timeStamp,
        duration,
        eventId: customApp.eventId,
        boothId: this.viewObject.boothId,
        attendeeId,
        uniqueId:
          localStorage.getItem('uniqueAnonymousId') ??
          uuidv5(this.ticketcodeAuthService.decodeToken()._id ?? uuidv4(), environment.MY_HASH_NAMESPACE)
      })
      .subscribe();
  }
}
